<mat-form-field
  [formGroup]="formGroup"
  [class.invalid]="control.touched && control.invalid"
  [class.password]="type === 'password'"
  appearance="fill"
  [class.mat-form-field-invalid]="customTextError == null ? undefined : true"
>
  <mat-label>{{ label }}</mat-label>

  <input
    *ngIf="kind === 'input'"
    matInput
    [type]="type"
    [placeholder]="placeholder"
    [attr.name]="name"
    [attr.id]="id"
    [formControl]="control"
    [maxlength]="maxLength"
    [minLength]="minLength"
    [readonly]="readonly"
    [value]="control.value"
    autocomplete="off"
    (input)="onInputChange($event)"
  />

  <button
    matSuffix
    *ngIf="passwordVisibilitySwitch"
    type="button"
    (click)="togglePasswordVisibility()"
    class="password-visibility-button"
  >
    <svg-icon
      [src]="hidePassword ? 'assets/icons/eye.svg' : 'assets/icons/eye-off.svg'"
    ></svg-icon>
  </button>

  <textarea
    *ngIf="kind === 'text_area'"
    matInput
    [cdkTextareaAutosize]="true"
    [cdkAutosizeMinRows]="minRows"
    [type]="type"
    [placeholder]="placeholder"
    [attr.name]="name"
    [attr.id]="id"
    [formControl]="control"
    [maxlength]="maxLength"
    [minLength]="minLength"
    [readonly]="readonly"
  ></textarea>

  <mat-error *ngIf="control.errors && control.touched">
    <span
      [innerHTML]="
        getDefaultValidatorErrorMessage(
          objectFn.keys(control.errors)[0],
          control.errors
        )
      "
    ></span>
  </mat-error>

  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>

  <p [innerHTML]="customTextError" class="customErrorText" *ngIf="customTextError != null"></p>
</mat-form-field>
